import { render, staticRenderFns } from "./debit.vue?vue&type=template&id=cb3596a0&"
import script from "./debit.vue?vue&type=script&lang=js&"
export * from "./debit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports